// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"8a08b3b1","134":"fa5d2bd8","237":"d4e7caf6","333":"c903e410","406":"1c46e31f","527":"1d238fd9","675":"d4e7caf6","702":"0d80943f","773":"448b211d","803":"dc0bdbbc","958":"dc0bdbbc"}[chunkId] + ".chunk.css";
};